import { FC, useState } from 'react';
import { Skeleton } from 'antd';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useGetMessagesQuery } from 'app/services/edpApiV1/consultations';
import { useIndicators } from 'features/indicators/hooks/use-indicators';
import type { IChatProps } from './types';
import style from './index.module.scss';

const Chat: FC<IChatProps> = ({ id }) => {
  const [size, setSize] = useState(10);

  const {
    data: messageData,
    isSuccess,
    isFetching,
    isLoading,
  } = useGetMessagesQuery({ chatId: id, size, page: 1 }, { refetchOnMountOrArgChange: true });

  const handleNextPage = () => {
    if (isFetching || isLoading) {
      return;
    }
    setSize(prevState => prevState + 10);
  };

  useIndicators(isSuccess, isFetching);

  if (messageData == null) {
    return <Skeleton active />;
  }

  return (
    <div id="scrollBlock" className={style.wrap}>
      <InfiniteScroll
        dataLength={(messageData.data ?? []).length}
        next={handleNextPage}
        hasMore={messageData.pagination.total > messageData.data.length}
        inverse={true}
        scrollableTarget="scrollBlock"
        loader={<Skeleton.Input active />}
      >
        {messageData &&
          messageData.data.length > 0 &&
          messageData.data.map(el => {
            return (
              <div
                className={`${style.message} ${el.consultantId ? style['hr-message'] : style['user-message']}`}
                key={el?.created}
              >
                <div className={style.data}>
                  <span className={style.hr}>{el?.userId && !el?.consultantId ? 'Сотрудник' : 'HR'}</span>
                  <span className={style.time}>{moment(new Date(el?.created)).format('DD.MM.YYYY, HH:mm')}</span>
                </div>
                <div className={style.chatText}>{el?.text}</div>
              </div>
            );
          })}
      </InfiniteScroll>
      {isFetching ? <Skeleton.Input active /> : null}
    </div>
  );
};

export default Chat;
